export default "__VITE_ASSET__us1jIn4a__"